import * as React from "react"
import {Box} from "@mui/material"
import {ButtonLoadingSeeker, IconSeeker} from "@ui-seeker/core"

import {useUnmatchedNewProductsTable} from "../../../@hooks"


export default function EditButton({ rowData }) {
    const { handleEditRowClick, rowEditClicked, rowIsLoading } = useUnmatchedNewProductsTable(rowData)
    
    const isOpenFormClass = rowEditClicked ? 'is-open' : ''
    const isLoadingClass = rowIsLoading ? 'is-loading' : ''

    return <Box component="span" className={`${isOpenFormClass} ${isLoadingClass}`} >
        <ButtonLoadingSeeker
            loading={false}
            label="Edit"
            startIcon={<IconSeeker icon={'pen-to-square'} />}
            onClick={handleEditRowClick}
        >
            Edit
        </ButtonLoadingSeeker>
    </Box>
}